import { render, staticRenderFns } from "./PositionBasedDiscountEditor.vue?vue&type=template&id=19597295&scoped=true&"
import script from "./PositionBasedDiscountEditor.vue?vue&type=script&lang=js&"
export * from "./PositionBasedDiscountEditor.vue?vue&type=script&lang=js&"
import style0 from "./PositionBasedDiscountEditor.vue?vue&type=style&index=0&id=19597295&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19597295",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSelect,VSimpleTable,VSpacer,VTextField})
